import { Modal, Spinner } from '@nextui-org/react'
import { createContext, useContext, useState } from 'react'

interface LoadingContextType {
    isLoading: boolean
    setIsLoading: (loading: boolean) => void
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

export function LoadingProvider({
    children
}: React.PropsWithChildren): JSX.Element {
    const [isLoading, setIsLoading] = useState(false)

    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            {children}
            <Modal
                isOpen={isLoading}
                hideCloseButton
                className="bg-transparent shadow-none"
            >
                <Spinner
                    size="lg"
                    color="primary"
                    label="Loading..."
                />
            </Modal>
        </LoadingContext.Provider>
    )
}

export const useLoading = (): LoadingContextType => {
    const context = useContext(LoadingContext)

    if (context === undefined) {
        throw new Error('useLoading must be used within a LoadingProvider')
    }

    return context
}
